module.exports = __webpack_public_path__ + "static/points-monitoring-4b767a5110e1ec8df10e4906a1f609fb.png";